@if (uiController === UIControlTyp.MultiSelectList) {
  <kendo-multiselect
    textField="name"
    valueField="id"
    [data]="YesNoList"
    [filterable]="true"
    (filterChange)="filterYesNoList($event)"
    [(ngModel)]="YesNos"
    placeholder="Wählen Sie einen Wert aus"
    (valueChange)="valueChanged()">
  </kendo-multiselect>
}
@if (uiController === UIControlTyp.DropDownList) {
  <kendo-dropdownlist
    class="fdb-kendo-dropdown"
    textField="name"
    valueField="id"
    [data]="YesNoList"
    [(ngModel)]="YesNo"
    (valueChange)="valueChanged()">
  </kendo-dropdownlist>
}
@if (uiController === UIControlTyp.GridSingleValueField) {
  {{ getName() }}
}
